// Generated by purs version 0.15.15
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Bounded from "../Data.Bounded/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Formatter_DateTime from "../Data.Formatter.DateTime/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as Data_Time_Local from "../Data.Time.Local/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
var bottom = /* #__PURE__ */ Data_Bounded.bottom(Data_Date_Component.boundedYear);
var bottom1 = /* #__PURE__ */ Data_Bounded.bottom(Data_Date_Component.boundedMonth);
var bottom2 = /* #__PURE__ */ Data_Bounded.bottom(Data_Date_Component.boundedDay);
var bottom3 = /* #__PURE__ */ Data_Bounded.bottom(Data_Time_Component.boundedHour);
var bottom4 = /* #__PURE__ */ Data_Bounded.bottom(Data_Time_Component.boundedMinute);
var bottom5 = /* #__PURE__ */ Data_Bounded.bottom(Data_Time_Component.boundedSecond);
var bottom6 = /* #__PURE__ */ Data_Bounded.bottom(Data_Time_Component.boundedMillisecond);
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Date.eqDate);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_Date_Component.eqYear);
var formatTime$prime = function (time) {
    var date = Data_Date.canonicalDate(bottom)(bottom1)(bottom2);
    return Data_Formatter_DateTime.format(new Data_List_Types.Cons(Data_Formatter_DateTime.Hours24.value, new Data_List_Types.Cons(new Data_Formatter_DateTime.Placeholder(":"), new Data_List_Types.Cons(Data_Formatter_DateTime.MinutesTwoDigits.value, Data_List_Types.Nil.value))))(new Data_DateTime.DateTime(date, time));
};
var formatTime = function (v) {
    return Data_Formatter_DateTime.format(new Data_List_Types.Cons(Data_Formatter_DateTime.Hours24.value, new Data_List_Types.Cons(new Data_Formatter_DateTime.Placeholder(":"), new Data_List_Types.Cons(Data_Formatter_DateTime.MinutesTwoDigits.value, Data_List_Types.Nil.value))))(new Data_DateTime.DateTime(v.value0, v.value1));
};
var formatDateTime = function (v) {
    return Data_Formatter_DateTime.format(new Data_List_Types.Cons(Data_Formatter_DateTime.DayOfMonthTwoDigits.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create("."), new Data_List_Types.Cons(Data_Formatter_DateTime.MonthTwoDigits.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create("."), new Data_List_Types.Cons(Data_Formatter_DateTime.YearAbsolute.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create(" "), new Data_List_Types.Cons(Data_Formatter_DateTime.Hours24.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create(":"), new Data_List_Types.Cons(Data_Formatter_DateTime.MinutesTwoDigits.value, Data_List_Types.Nil.value))))))))))(new Data_DateTime.DateTime(v.value0, v.value1));
};
var formatDateCommaTimeShort = function (v) {
    return Data_Formatter_DateTime.format(new Data_List_Types.Cons(Data_Formatter_DateTime.DayOfMonthTwoDigits.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create("."), new Data_List_Types.Cons(Data_Formatter_DateTime.MonthTwoDigits.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create(", "), new Data_List_Types.Cons(Data_Formatter_DateTime.Hours24.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create(":"), new Data_List_Types.Cons(Data_Formatter_DateTime.MinutesTwoDigits.value, Data_List_Types.Nil.value))))))))(new Data_DateTime.DateTime(v.value0, v.value1));
};
var formatDateCommaTime = function (v) {
    return Data_Formatter_DateTime.format(new Data_List_Types.Cons(Data_Formatter_DateTime.DayOfMonthTwoDigits.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create("."), new Data_List_Types.Cons(Data_Formatter_DateTime.MonthTwoDigits.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create("."), new Data_List_Types.Cons(Data_Formatter_DateTime.YearAbsolute.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create(", "), new Data_List_Types.Cons(Data_Formatter_DateTime.Hours24.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create(":"), new Data_List_Types.Cons(Data_Formatter_DateTime.MinutesTwoDigits.value, Data_List_Types.Nil.value))))))))))(new Data_DateTime.DateTime(v.value0, v.value1));
};
var formatDate$prime = function (date) {
    var time = new Data_Time.Time(bottom3, bottom4, bottom5, bottom6);
    return Data_Formatter_DateTime.format(new Data_List_Types.Cons(Data_Formatter_DateTime.DayOfMonthTwoDigits.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create("."), new Data_List_Types.Cons(Data_Formatter_DateTime.MonthTwoDigits.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create("."), new Data_List_Types.Cons(Data_Formatter_DateTime.YearAbsolute.value, Data_List_Types.Nil.value))))))(new Data_DateTime.DateTime(date, time));
};
var formatDay = function (v) {
    return formatDate$prime(v);
};
var formatDate = function (v) {
    return Data_Formatter_DateTime.format(new Data_List_Types.Cons(Data_Formatter_DateTime.DayOfMonthTwoDigits.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create("."), new Data_List_Types.Cons(Data_Formatter_DateTime.MonthTwoDigits.value, new Data_List_Types.Cons(Data_Formatter_DateTime.Placeholder.create("."), new Data_List_Types.Cons(Data_Formatter_DateTime.YearAbsolute.value, Data_List_Types.Nil.value))))))(new Data_DateTime.DateTime(v.value0, v.value1));
};
var dayOfWeekShort = function (v) {
    if (v instanceof Data_Date_Component.Monday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.mon);
    };
    if (v instanceof Data_Date_Component.Tuesday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.tue);
    };
    if (v instanceof Data_Date_Component.Wednesday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.wed);
    };
    if (v instanceof Data_Date_Component.Thursday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.thu);
    };
    if (v instanceof Data_Date_Component.Friday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.fri);
    };
    if (v instanceof Data_Date_Component.Saturday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.sat);
    };
    if (v instanceof Data_Date_Component.Sunday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.sun);
    };
    throw new Error("Failed pattern match at Restaumatic.Format.DateTime (line 118, column 18 - line 125, column 43): " + [ v.constructor.name ]);
};
var formatFriendlyDateTime = function (nowDate) {
    return function (v) {
        if (eq(nowDate)(v.value0)) {
            return formatTime(v);
        };
        if (eq1(Data_Date.year(nowDate))(Data_Date.year(v.value0))) {
            return dayOfWeekShort(Data_Date.weekday(v.value0)) + (", " + formatDateCommaTimeShort(v));
        };
        if (Data_Boolean.otherwise) {
            return dayOfWeekShort(Data_Date.weekday(v.value0)) + (", " + formatDateCommaTime(v));
        };
        throw new Error("Failed pattern match at Restaumatic.Format.DateTime (line 101, column 1 - line 101, column 58): " + [ nowDate.constructor.name, v.constructor.name ]);
    };
};
var dayOfWeek = function (v) {
    if (v instanceof Data_Date_Component.Monday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.monday);
    };
    if (v instanceof Data_Date_Component.Tuesday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.tuesday);
    };
    if (v instanceof Data_Date_Component.Wednesday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.wednesday);
    };
    if (v instanceof Data_Date_Component.Thursday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.thursday);
    };
    if (v instanceof Data_Date_Component.Friday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.friday);
    };
    if (v instanceof Data_Date_Component.Saturday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.saturday);
    };
    if (v instanceof Data_Date_Component.Sunday) {
        return Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.date.weekdays.sunday);
    };
    throw new Error("Failed pattern match at Restaumatic.Format.DateTime (line 108, column 13 - line 115, column 46): " + [ v.constructor.name ]);
};
var formatFriendlyDate = function (v) {
    return dayOfWeek(Data_Date.weekday(v.value0)) + (", " + formatDate(new Data_Time_Local.LocalDateTime(v.value0, v.value1)));
};
export {
    formatDate,
    formatDate$prime,
    formatDateTime,
    formatDay,
    formatFriendlyDate,
    formatFriendlyDateTime,
    formatTime,
    formatTime$prime
};
